// Dependency-free date formatting that reproduces — byte-for-byte — the exact
// output of the moment().format() calls previously used in the panel, so dropping
// moment changes NOTHING visually. Uses LOCAL time (moment's default) and returns
// 'Invalid date' for unparseable input (moment's behaviour for an invalid date).
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const p2 = (n) => String(n).padStart(2, '0');

function _d(input) {
    // Treat null/undefined/'' as invalid (new Date(null) would be epoch 1970).
    // Call sites already guard falsy values, but this keeps the helper safe.
    if (input === null || input === undefined || input === '') return null;
    const d = input instanceof Date ? input : new Date(input);
    return isNaN(d.getTime()) ? null : d;
}

// moment(x).format('MMM DD, YYYY')  ->  e.g. "Jun 08, 2026"
export function formatMonDayYear(input) {
    const d = _d(input);
    if (!d) return 'Invalid date';
    return `${MONTHS[d.getMonth()]} ${p2(d.getDate())}, ${d.getFullYear()}`;
}

// moment(x).format('YYYY-MM-DD HH:mm:ss')  ->  e.g. "2026-06-08 14:30:05"
export function formatDateTime(input) {
    const d = _d(input);
    if (!d) return 'Invalid date';
    return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())} ${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}`;
}
